import {
  CLEAR_PROPS_DATA,
  CREATE_SUB_ASSET_TRANSFER_SUCCESS,
  FETCH_ASSET_WITH_PARENT_KEY_SUCCESS,
  FETCH_CHILD_ASSET_BY_ID_SUCCESS,
  FETCH_SUB_ASSET_TRANSFER_SUCCESS,
  GET_JOB_CARD_FROM_ASSET,
  GET_JOB_CARD_FROM_ASSET_START,
  GET_JOB_CARD_FROM_ASSET_STOP,
  GET_SUB_ASSET_TRANSFER_SUCCESS,
  SAVE_SUB_ASSET_TRANSFER_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  childAssets: [],
  parentAssets: [],
  isStartFromActivity: false,
  fromJobCards: [],
  toJobCards: [],
  jobCardsLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SUB_ASSET_TRANSFER_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_SUB_ASSET_TRANSFER_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_SUB_ASSET_TRANSFER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_SUB_ASSET_TRANSFER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case FETCH_CHILD_ASSET_BY_ID_SUCCESS: {
      return {
        ...state,
        childAssets: action.data,
      }
    }

    case CLEAR_PROPS_DATA: {
      return {
        ...state,
        childAssets: [],
        parentAssets: [],
      }
    }

    case FETCH_ASSET_WITH_PARENT_KEY_SUCCESS: {
      return {
        ...state,
        parentAssets: action.data,
      }
    }

    case GET_JOB_CARD_FROM_ASSET: {
      const data = {};
      if(action.direction === 'to') {
        data['toJobCards'] = action.data;
      } else {
        data['fromJobCards'] = action.data;
      }
      return {
        ...state,
        ...data
      }
    }

    case GET_JOB_CARD_FROM_ASSET_START: {
      return {
        ...state,
        jobCardsLoading: true,
      }
    }

    case GET_JOB_CARD_FROM_ASSET_STOP: {
      return {
        ...state,
        jobCardsLoading: false,
      }
    }

    default:
      return state;
  }
}
